(function(angular) {
    'use strict';
    angular
        .module('wtUi.wtMenu', ['wtUi.services', 'wtUi.filters', 'ui.router'])
        .constant('md5', window.md5);
})(window.angular);
